import React, { useState } from "react";
import { Outlet } from "react-router-dom";
import Sidebar from "./Sidebar";
import Topbar from "./Topbar";
import "./Layout.css";

const Layout = () => {
  const [isViewed, setIsViewed] = useState(false);

  return (
    <div className="layout-container">
      <Sidebar isViewed={isViewed} setIsViewed={setIsViewed} />
      <div className={`main-content ${isViewed ? "collapsed" : ""}`}>
        <Topbar />
        <div className="content-wrapper">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default Layout;
